import { Icon, Stack } from '@ui-components/neo.tax';

import { StyledCheckCircle, StyledConnectedText } from './select-providers.styled';

export const Connected = (): React.ReactElement => (
  <Stack alignItems="center" space={1}>
    <Icon node={<StyledCheckCircle />} size={5} variant="none" />
    <StyledConnectedText as="label" fontWeight="medium" fontSize="xs">
      Connected
    </StyledConnectedText>
  </Stack>
);
